// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-6d70ac6c]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.text-widget[data-v-6d70ac6c]{padding:30px 10px}.text-widget__content[data-v-6d70ac6c]{margin:0 auto;max-width:1200px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
